import { render } from "./HeroSettingSystemAbout.vue?vue&type=template&id=3ed1851e&scoped=true"
import script from "./HeroSettingSystemAbout.vue?vue&type=script&lang=js"
export * from "./HeroSettingSystemAbout.vue?vue&type=script&lang=js"

import "./HeroSettingSystemAbout.vue?vue&type=style&index=0&id=3ed1851e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ed1851e"]])

export default __exports__